var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "20px",
    viewBox: "0 0 75 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_M",
    transform: "translate(-122.000000, -78.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(54.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8166715,0.999258957 L132.599655,0.999258957 C132.859856,0.999258957 133.10981,1.10067897 133.296446,1.28198449 L142.561021,10.2819845 C142.957161,10.6668114 142.966331,11.29991 142.581505,11.6960497 C142.574776,11.7029762 142.567947,11.7098048 142.561021,11.7165334 L133.296446,20.7165334 C133.10981,20.8978389 132.859856,20.999259 132.599655,20.999259 L69.8166715,20.999259 C69.2643868,20.999259 68.8166715,20.5515437 68.8166715,19.999259 C68.8166715,19.7239345 68.9301867,19.4607907 69.1304576,19.2718592 L77.1285126,11.7266587 C77.5302444,11.3476732 77.5486839,10.7147768 77.1696984,10.313045 C77.1563726,10.2989194 77.1426382,10.285185 77.1285126,10.2718592 L69.1304576,2.72665871 C68.7287258,2.34767321 68.7102863,1.71477679 69.0892718,1.313045 C69.2782032,1.11277409 69.5413471,0.999258957 69.8166715,0.999258957 Z",
    id: "Rectangle-Copy-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleM);
export default __webpack_public_path__ + "static/media/middleM.a5a80e4189704e5635f0bd474a2d9d6f.svg";
export { ForwardRef as ReactComponent };